// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_m6-1";
export var rowFirst = "_m6-3";
export var rowLast = "_m6-5";
export var rowMiddle = "_m6-4";
export var ticketListScroll = "_m6-2";
export var ticketStack = "_m6-0";